(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ashwagandha-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // ========== Countdown ==========
    var t = document.querySelector('[data-vx-timer]');
    if (t) {
      var hh = parseInt(t.dataset.hours,10)||0;
      var mm = parseInt(t.dataset.minutes,10)||0;
      var ss = parseInt(t.dataset.seconds,10)||0;
      var total = hh*3600 + mm*60 + ss;
      var hEl = t.querySelector('[data-h]'), mEl = t.querySelector('[data-m]'), sEl = t.querySelector('[data-s]');
      function pad(n){ return n<10 ? '0'+n : ''+n; }
      function tick(){
        if (total <= 0) { total = hh*3600 + mm*60 + ss; }
        var h = Math.floor(total/3600), m = Math.floor((total%3600)/60), s = total%60;
        hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
        total--;
      }
      tick(); setInterval(tick, 1000);
    }

    // ========== Gallery thumbnails ==========
    var main = document.getElementById('vx-main-img');
    var thumbs = document.querySelectorAll('.vx-thumb');
    thumbs.forEach(function(b){
      b.addEventListener('click', function(){
        if (main) main.src = b.dataset.img;
        thumbs.forEach(function(x){ x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });

    // ========== Popup ==========
    document.querySelectorAll('[data-vx-popup]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-vx-popup');
        var pop = document.querySelector('[data-vx-popup-target="'+key+'"]');
        if (pop) { pop.classList.add('is-open'); document.body.style.overflow='hidden'; }
      });
    });
    document.querySelectorAll('[data-vx-popup-close]').forEach(function(c){
      c.addEventListener('click', function(){
        c.closest('.vx-popup').classList.remove('is-open');
        document.body.style.overflow='';
      });
    });
    document.querySelectorAll('.vx-popup').forEach(function(p){
      p.addEventListener('click', function(e){
        if (e.target === p) { p.classList.remove('is-open'); document.body.style.overflow=''; }
      });
    });

    // ========== Sticky CTA (mobile) ==========
    var trig = document.getElementById('vx-sticky-trigger');
    var sticky = document.getElementById('vx-sticky');
    if (trig && sticky) {
      sticky.addEventListener('click', function(){
        var url = sticky.dataset.link;
        if (url && url !== '#') window.location.href = url;
      });
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting && e.boundingClientRect.top < 0) sticky.classList.add('is-show');
          else sticky.classList.remove('is-show');
        });
      });
      obs.observe(trig);
    }

    // ========== FAQ ==========
    document.querySelectorAll('[data-vx-faq]').forEach(function(q){
      q.addEventListener('click', function(){
        q.closest('.vx-faq-item').classList.toggle('is-open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-counts-dynamic"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function () {
    // Create overlay element
    const overlay = document.createElement("div");
    overlay.classList.add("vib-unique-overlay");
    document.body.appendChild(overlay);

    document.addEventListener("click", function (event) {
      const button = event.target.closest(".learn-more");
      const close = event.target.closest(".close-popup");
      const activePopup = document.querySelector(".popup.active-popup");

      // Show popup
      if (button) {
        const popup = document.getElementById(button.dataset.popupId);
        if (popup) {
          popup.style.display = "flex";
          popup.classList.add("active-popup");
          overlay.style.display = "block"; // Show overlay
          document.body.classList.add("no-scroll"); // Disable scrolling
        }
      }

      // Close popup
      else if (close) {
        const popup = document.getElementById(close.dataset.popupId);
        if (popup) {
          popup.style.display = "none";
          popup.classList.remove("active-popup");
          overlay.style.display = "none"; // Hide overlay
          document.body.classList.remove("no-scroll"); // Enable scrolling
        }
      }

      // Close popup on outside click
      else if (activePopup && !activePopup.contains(event.target)) {
        activePopup.style.display = "none";
        activePopup.classList.remove("active-popup");
        overlay.style.display = "none"; // Hide overlay
        document.body.classList.remove("no-scroll"); // Enable scrolling
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-counts"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function () {
    // Create overlay element
    const overlay = document.createElement("div");
    overlay.classList.add("vib-unique-overlay");
    document.body.appendChild(overlay);

    document.addEventListener("click", function (event) {
      const button = event.target.closest(".learn-more");
      const close = event.target.closest(".close-popup");
      const activePopup = document.querySelector(".popup.active-popup");

      // Show popup
      if (button) {
        const popup = document.getElementById(button.dataset.popupId);
        if (popup) {
          popup.style.display = "flex";
          popup.classList.add("active-popup");
          overlay.style.display = "block"; // Show overlay
          document.body.classList.add("no-scroll"); // Disable scrolling
        }
      }

      // Close popup
      else if (close) {
        const popup = document.getElementById(close.dataset.popupId);
        if (popup) {
          popup.style.display = "none";
          popup.classList.remove("active-popup");
          overlay.style.display = "none"; // Hide overlay
          document.body.classList.remove("no-scroll"); // Enable scrolling
        }
      }

      // Close popup on outside click
      else if (activePopup && !activePopup.contains(event.target)) {
        activePopup.style.display = "none";
        activePopup.classList.remove("active-popup");
        overlay.style.display = "none"; // Hide overlay
        document.body.classList.remove("no-scroll"); // Enable scrolling
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
